import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { IDropdownButtonItem } from './k-dropdown-button.interface';

@Component({
  selector: 'k-dropdown-button',
  templateUrl: './k-dropdown-button.component.html',
  styleUrls: ['./k-dropdown-button.component.scss']
})
export class KDropdownButtonComponent implements OnChanges {
  _items: MenuItem[] = [];
  @Input() label: string = 'button';
  @Input() menuItems: IDropdownButtonItem[];
  @Output() onItemClick: EventEmitter<IDropdownButtonItem> = new EventEmitter<IDropdownButtonItem>();
  icon: string = 'chevron-down';
  constructor() { }


  ngOnChanges() {
    if (this.menuItems) {
      this._items = this.menuItems.map(i => {
        return {
          escape: false,
          label: TEMPLATE_MENU_ITEM(i.label, i.pic),
          command: () => {
            if(!i.label.startsWith('not')){
              this.itemClick(i)
            }
          }
        }
      });
      for (let i = 1; i < this._items.length; i = i + 2) {
        this._items.splice(i, 0, { separator: true });
      }
    }
  }

  itemClick(item: IDropdownButtonItem) {
    this.onItemClick.emit(item);
  }

  onShowMenu() {
    this.icon = 'chevron-up';
  }

  onHideMenu() {
    this.icon = 'chevron-down';

  }
}

const TEMPLATE_MENU_ITEM = (label: string, pic: string): string => {
  return `
  <div class="flex items-center">
    <img class="w-5 h-5 mr-3" src="${pic}" />
    <span class="text-white text-sm"> ${label}</span>
</div>
`
}

//./assets/img/Icon/Cur-Kmon.png